module.exports = __webpack_public_path__ + "57509c061db35fd56bc5f3b6db18b0ac.png";